var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 2.66683C13.6666 3.0335 13.3666 3.3335 13 3.3335H7.66665V2.00016H13C13.3666 2.00016 13.6666 2.30016 13.6666 2.66683ZM6.33331 8.66683H0.99998C0.633313 8.66683 0.333313 8.96683 0.333313 9.3335C0.333313 9.70016 0.633313 10.0002 0.99998 10.0002H6.33331V8.66683ZM4.33331 0.333496C3.27998 0.333496 2.39998 1.04016 2.10665 2.00016H0.99998C0.633313 2.00016 0.333313 2.30016 0.333313 2.66683C0.333313 3.0335 0.633313 3.3335 0.99998 3.3335H2.10665C2.39332 4.2935 3.27998 5.00016 4.33331 5.00016C5.61998 5.00016 6.66665 3.9535 6.66665 2.66683C6.66665 1.38016 5.61998 0.333496 4.33331 0.333496ZM13 8.66683H11.8933C11.6066 7.70683 10.72 7.00016 9.66665 7.00016C8.37998 7.00016 7.33331 8.04683 7.33331 9.3335C7.33331 10.6202 8.37998 11.6668 9.66665 11.6668C10.72 11.6668 11.6 10.9602 11.8933 10.0002H13C13.3666 10.0002 13.6666 9.70016 13.6666 9.3335C13.6666 8.96683 13.3666 8.66683 13 8.66683Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a9cdfb4471b1082536cfc4b9eed115e8.svg";
export { ForwardRef as ReactComponent };